import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

/* =========================
   PUBLIC PAGES
========================= */

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Repair from "./pages/Repair";
import Parts from "./pages/Parts";
import Service from "./pages/Service";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import Search from "./pages/Search";

import ProductDetails from "./pages/ProductDetails";
import PartDetails from "./pages/PartDetails";

/* =========================
   ADMIN PAGES
========================= */

import AdminDashboard from "./pages/Dashboard/AdminDashboard";
import AdminProducts from "./pages/Dashboard/AdminProducts";
import AddProduct from "./pages/Dashboard/AddProductForm";
import AdminOrders from "./pages/Dashboard/AdminOrders";
import AdminSettings from "./pages/Dashboard/AdminSettings";
import AdminAnalysis from "./pages/Dashboard/AdminAnalysis";
import AdminRepairManager from "./pages/Dashboard/AdminRepairsManager";
import AdminParts from "./pages/Dashboard/AdminParts";
import AdminSales from "./pages/Dashboard/AdminSales";
import AddPartForm from "./pages/Dashboard/AddPartsForm";
import AdminDevicePurchases from "./pages/Dashboard/AdminDevicePurchases";
import AdminExpensesManager from "./pages/Dashboard/AdminExpensesManager";
import AdminSuppliers from "./pages/Dashboard/AdminSuppliers";
import AdminCustomers from "./pages/Dashboard/AdminCustomers";
import AdminPayroll from "./pages/Dashboard/AdminPayroll";

/* =========================
   USER PAGES
========================= */

import UserDashboard from "./pages/Dashboard/UserDashboard";

/* =========================
   LAYOUTS
========================= */

import AdminLayout from "./layouts/AdminLayout";
import UserLayout from "./layouts/UserLayout";

/* =========================
   COMPONENTS
========================= */

import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";

import CookieConsent from "./components/cookies/CookieConsent";
import VisitorTracker from "./components/analytics/VisitorTracker";
//import AnimatedMascot from "./components/animation/AnimatedMascot";

/* =========================
   CONTEXT
========================= */

import { ProductsProvider } from "./context/ProductsContext";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";

/* =========================
   GLOBAL STYLES
========================= */

import "@fortawesome/fontawesome-free/css/all.min.css";
import "./styles.css";

/* =========================================================
   MAIN LAYOUT
========================================================= */

const Layout = () => {
  const location = useLocation();

  /* Kontrollojmë nëse jemi në dashboard */
  const isDashboard =
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/user");

  return (
    <>
      {/* =========================
          HEADER
          Vetëm në faqet publike
      ========================= */}

      {!isDashboard && <Header />}

      {/* =========================
          MAIN CONTENT
      ========================= */}

      <main
        style={{
          padding: isDashboard ? "2rem" : "0",
        }}
      >
        <Routes>
          {/* =================================================
              PUBLIC ROUTES
          ================================================= */}

          <Route
            path="/"
            element={<Home />}
          />

          <Route
            path="/shop"
            element={<Shop />}
          />

          <Route
            path="/product/:brand/:model"
            element={<ProductDetails />}
          />

          <Route
            path="/parts/details/:id"
            element={<PartDetails />}
          />

          <Route
            path="/repair"
            element={<Repair />}
          />

          <Route
            path="/parts"
            element={<Parts />}
          />

          <Route
            path="/service"
            element={<Service />}
          />

          <Route
            path="/contact"
            element={<Contact />}
          />

          <Route
            path="/login"
            element={<Login />}
          />

          <Route
            path="/search"
            element={<Search />}
          />

          {/* =================================================
              ADMIN ROUTES
          ================================================= */}

          <Route
            path="/admin"
            element={<AdminLayout />}
          >
            <Route
              path="dashboard"
              element={<AdminDashboard />}
            />

            <Route
              path="products"
              element={<AdminProducts />}
            />

            <Route
              path="products/add"
              element={<AddProduct />}
            />
              <Route
                path="/admin/suppliers"
                element={<AdminSuppliers />}
              />
              <Route
                path="customers"
                element={<AdminCustomers />}
              />
             <Route
                  path="device-purchases"
                  element={<AdminDevicePurchases />}
            />

            <Route
                path="/admin/expenses"
                element={<AdminExpensesManager />}
              />


            <Route
                path="/admin/payroll"
                element={<AdminPayroll />}
              />
            <Route
              path="repairs"
              element={<AdminRepairManager />}
            />

            <Route
              path="orders"
              element={<AdminOrders />}
            />

            <Route
              path="settings"
              element={<AdminSettings />}
            />

            <Route
              path="analysis"
              element={<AdminAnalysis />}
            />

            <Route
              path="sales"
              element={<AdminSales />}
            />

            <Route
              path="parts"
              element={<AdminParts />}
            />

            <Route
              path="parts/add"
              element={<AddPartForm />}
            />
          </Route>

          {/* =================================================
              USER ROUTES
          ================================================= */}

          <Route
            path="/user"
            element={<UserLayout />}
          >
            <Route
              path="dashboard"
              element={<UserDashboard />}
            />
          </Route>
        </Routes>
      </main>

      {!isDashboard && <VisitorTracker />}

      {/* =========================
          COOKIE CONSENT
          Vetëm në faqet publike
      ========================= */}

      {!isDashboard && <CookieConsent />}

      {/* =========================
          MASKOTA + FOOTER
          Vetëm në faqet publike
      ========================= */}

      {!isDashboard && (
        <>
      

          <Footer />
        </>
      )}
    </>
  );
};

/* =========================================================
   APP
========================================================= */

function App() {
  return (
    <AuthProvider>
      <ProductsProvider>
        <LanguageProvider>
          <Router>
            <Layout />
          </Router>
        </LanguageProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}

export default App;